import React from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaPhone, FaHeart, FaEye } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { addToWishlist } from '../../redux/slices/uiSlice';
import toast from 'react-hot-toast';

const ProductCard = ({ product }) => {
  const dispatch = useDispatch();

  const getStockStatus = (stock) => {
    if (stock <= 0) return { text: 'Out of Stock', bg: 'bg-rose-100 text-rose-700' };
    if (stock <= 5) return { text: 'Low Stock', bg: 'bg-amber-100 text-amber-700' };
    return { text: 'In Stock', bg: 'bg-emerald-100 text-emerald-700' };
  };

  const stockStatus = getStockStatus(product.inventory?.stock);
  const primaryImage = product.images?.find((img) => img.isPrimary) || product.images?.[0];
  const discount = product.pricing?.discountPercentage;

  const handleWishlist = (e) => {
    e.preventDefault();
    dispatch(addToWishlist(product._id));
    toast.success('Added to wishlist!');
  };

  return (
    <div className="card group relative overflow-hidden">
      <div className="absolute inset-x-4 top-4 z-10 flex flex-col gap-2">
        {discount > 0 && (
          <span className="badge bg-rose-500 text-white">-{discount}% OFF</span>
        )}
        {product.status?.newArrival && (
          <span className="badge bg-emerald-500 text-white">New Arrival</span>
        )}
      </div>

      <button
        onClick={handleWishlist}
        className="absolute right-4 top-4 z-10 w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-red-50"
      >
        <FaHeart className="text-gray-400 hover:text-red-500" />
      </button>

      <Link to={`/products/${product._id}`} className="block">
        <div className="relative overflow-hidden bg-slate-100 dark:bg-slate-900">
          <img
            src={primaryImage?.url || "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300' fill='%23cbd5e1'%3E%3Crect width='300' height='300' fill='%23f1f5f9'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='system-ui' font-size='14' fill='%2394a3b8'%3ENo Image%3C/text%3E%3C/svg%3E"}
            alt={product.name}
            className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-slate-950/0 group-hover:bg-slate-950/20 transition-colors duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
            <span className="rounded-full bg-white/95 text-slate-900 px-4 py-2 text-sm font-semibold shadow-lg">View details</span>
          </div>
        </div>

        <div className="p-5">
          <p className="text-sm text-slate-500 dark:text-slate-400 mb-2">{product.brand?.name}</p>
          <h3 className="text-lg font-semibold mb-3 text-slate-900 dark:text-white line-clamp-2 transition-colors duration-300 group-hover:text-primary-600">
            {product.name}
          </h3>

          <div className="flex flex-wrap gap-2 text-xs text-slate-500 dark:text-slate-400 mb-4">
            {product.specifications?.ram && (
              <span className="rounded-full bg-slate-100 dark:bg-slate-800 px-3 py-1">{product.specifications.ram} RAM</span>
            )}
            {product.specifications?.storage && (
              <span className="rounded-full bg-slate-100 dark:bg-slate-800 px-3 py-1">{product.specifications.storage}</span>
            )}
          </div>

          <div className="flex items-end justify-between gap-4 mb-5">
            <div>
              <p className="text-lg font-bold text-primary-600">RS:{product.pricing?.salePrice?.toLocaleString()}</p>
              {product.pricing?.originalPrice > product.pricing?.salePrice && (
                <p className="text-sm text-slate-500 line-through">RS:{product.pricing.originalPrice.toLocaleString()}</p>
              )}
            </div>
            <span className={`badge ${stockStatus.bg}`}>{stockStatus.text}</span>
          </div>
        </div>
      </Link>

      <div className="px-5 pb-5 grid gap-3 sm:grid-cols-2">
        <a
          href={`https://wa.me/923488477649?text=I'm%20interested%20in%20${encodeURIComponent(product.name)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-3 py-2 text-sm font-semibold text-white hover:bg-emerald-600 transition-all duration-300"
        >
          <FaWhatsapp /> Inquiry
        </a>
        <a
          href="tel:+923488477649"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-600 px-3 py-2 text-sm font-semibold text-white hover:bg-primary-700 transition-all duration-300"
        >
          <FaPhone /> Call
        </a>
      </div>
    </div>
  );
};

export default ProductCard;